import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { getCategory } from '../../../actions/categoryAction';
import { url } from '../../../config';
import { getLastURL, getSecondLastURL } from '../../../helper';
import { FormattedMessage } from 'react-intl';
import { SoryByFilterAction } from '../../../actions/productActions';
import { ALL_PRODUCTS_FAIL } from '../../../constants/productConstants';
import { IMAGES } from '../../../constants';


const ProtectedNav = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const { category } = useSelector(state => state.categories);
    const path = getLastURL(location);
    const path2 = getSecondLastURL(location);

    // useEffect(() => {
    //     if(!category)
    //     {
    //         dispatch(getCategory());
    //     }
    // }, [category])

    const handleTabChange = () => {
        dispatch({
            type: ALL_PRODUCTS_FAIL,
            payload: null
        })
        dispatch(SoryByFilterAction({}))
    }
    return (
        <div className="header-menu page-header-menu">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <nav className="navbar navbar-default px-0">

                            <div className="navbar-header">
                                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                </button>
                                <a className="navbar-brand visible-xs" href="/">MENU</a>
                            </div>
                            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                                {/* <ul className="nav navbar-nav">
                                    {
                                        category && category.categories && category.categories.map((category) => {
                                            return (
                                                <li>
                                                    <a onClick={() => handleTabChange()}>
                                                        <Link className={path2 === 'category' && category.slug === path || path2 === category.slug ? "active" : null} to={url + '/category/' + category.slug}>
                                                            <FormattedMessage
                                                                id={"category." + category.slug}
                                                                defaultMessage={category.name}
                                                            />
                                                        </Link>
                                                    </a>
                                                </li>
                                            )
                                        })
                                    }
                                </ul> */}

                                <div className="icons-navs">
                                    {category?.categories?.map((category, catIndex) => (
                                        <Link
                                            key={category.slug}
                                            to={`${url}/category/${category.slug}`}
                                            className={`icons-nav-single ${(path2 === "category" && category.slug === path) || path2 === category.slug
                                                ? "active"
                                                : ""
                                                }`}
                                        >
                                            {/* <img src={IMAGES.i.catIndex.Img} alt={category.name} /> */}
                                            <img
                                                className={`${(path2 === "category" && category.slug === path) || path2 === category.slug
                                                    ? ""
                                                    : "img-disabled"
                                                    }`}
                                                src={IMAGES[`i${catIndex + 1}Img`] || IMAGES.defaultImg}
                                                alt={category.name}
                                            />
                                            <span>
                                                <FormattedMessage id={`category.${category.slug}`} defaultMessage={category.name} />
                                            </span>
                                        </Link>
                                    ))}

                                    <Link
                                        key="messages"
                                        to={`${url}/message`}
                                        className={`icons-nav-single ${path === "message" ? "active" : ""} `}
                                    >
                                        <img src={IMAGES.i7Img} alt="messages " className={`${path === "message" ? "" : "img-disabled"}`} />
                                        <span> <FormattedMessage id='Messages' defaultMessage='Messages' /></span>
                                    </Link>

                                    <Link
                                        key="favorites"
                                        to={`${url}/favorites/diamonds`}
                                        className={`icons-nav-single ${path2 === "favorites" ? "active" : ""}`}
                                    >
                                        <img src={IMAGES.i8Img} alt="Messages" className={`${path2 === "favorites" ? "" : "img-disabled"}`} />
                                        <span><FormattedMessage id='Trackitems' defaultMessage='Track Items' /></span>
                                    </Link>

                                    <Link
                                        key="daily_specials"
                                        to={`${url}/advertised-products`}
                                        className={`icons-nav-single ${path === "advertised-products" ? "active" : ""}`}
                                    >
                                        <img src={IMAGES.offerImg} className={`${path === "advertised-products" ? "" : "img-disabled"}`}  alt="daily_specials" />
                                        <span><FormattedMessage id='Daily_specials' defaultMessage='Specials' /> </span>
                                    </Link>

                                </div>

                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProtectedNav
